import React, { useMemo } from 'react';
import { useDateTimePicker } from '../../../../index';
import { Container, Row, Day, DateLabel } from './styled';
import { useDateSelection } from '../..';
import {
  getWeeksInMonth,
  format,
  getDaysInMonth,
  getWeekOfMonth,
  startOfMonth,
  addDays,
  getDay,
  isSameDay,
  addHours,
  getHours,
  addMinutes,
  getMinutes,
  isSameYear,
} from 'date-fns';
import { isInRange } from '../../../../util';

const today = new Date();

export const Calendar = () => {
  const { selectedValue, setSelectedValue, minDate, maxDate, t } =
    useDateTimePicker();
  const { activeDate } = useDateSelection();

  const weeks = useMemo(() => {
    const startDate = addMinutes(
      addHours(startOfMonth(activeDate), getHours(selectedValue)),
      getMinutes(selectedValue),
    );

    const list = Array.from<
      { length: number },
      Record<string, Date | undefined>
    >({ length: getWeeksInMonth(startDate) }, () => ({
      '0': undefined,
      '1': undefined,
      '2': undefined,
      '3': undefined,
      '4': undefined,
      '5': undefined,
      '6': undefined,
    }));

    for (let i = 0; i < getDaysInMonth(startDate); i++) {
      const date = addDays(startDate, i);
      list[getWeekOfMonth(date) - 1][getDay(date)] = date;
    }

    return list as Record<string, Date>[];
  }, [activeDate, selectedValue]);

  return (
    <Container>
      <Row>
        <Day>{t('days.su')}</Day>
        <Day>{t('days.mo')}</Day>
        <Day>{t('days.tu')}</Day>
        <Day>{t('days.we')}</Day>
        <Day>{t('days.th')}</Day>
        <Day>{t('days.fr')}</Day>
        <Day>{t('days.sa')}</Day>
      </Row>
      {weeks.map((week, index) => (
        <Row key={index}>
          {Object.values(week).map((date, index) => (
            <DateLabel
              key={index}
              type="button"
              onClick={() => date && setSelectedValue(date)}
              isSelected={!!selectedValue && isSameDay(date, selectedValue)}
              isToday={isSameYear(date, today) && isSameDay(date, today)}
              disabled={!isInRange(date, minDate, maxDate)}
            >
              <p>{date ? format(date, 'd') : ' '}</p>
            </DateLabel>
          ))}
        </Row>
      ))}
    </Container>
  );
};
